import i18n from 'i18next';

import { registerValidator } from 'core/forms';

const isNumber = ({ fieldValue, validator: { isRequired } = {} }) => {
  const isEmpty = fieldValue == null || fieldValue === '';

  return {
    hasError: isEmpty ? isRequired : Number.isNaN(Number(fieldValue)),
    error: i18n.t('error-not-number'),
    isRequired,
  };
};

registerValidator('isNumber', isNumber);

export default isNumber;
